import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cleanNumber' })
export class CleanNumberPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '0';
    }

    if (value === 0) {
      return '0';
    }

    let finalResult = value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);

    return finalResult.replace('.', ',');
  }
}
